import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import {DEFAULT_LANG, LANG_STORAGE_KEY} from './constant';
import {initStoredLanguage, resolveBootLanguage} from './utils/detectLanguage';
import {syncDayjsLocale} from './utils/dayjsLocale';

// 進站語系只在這裡決定一次：先確定記住的語系，再以它（或網址的 ?lang=）初始化，
// 只抓這一個語系的語言檔；各頁不再各自 changeLanguage 套用記住的語系
initStoredLanguage();
const initialLang = resolveBootLanguage(
  window.location.search,
  localStorage.getItem(LANG_STORAGE_KEY),
);

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: DEFAULT_LANG,
    lng: initialLang,
    interpolation: {
      escapeValue: false,
    },
  });

// Sync <html lang> attribute and date locale with current language (WCAG accessibility)
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng || DEFAULT_LANG;
  syncDayjsLocale(lng);
});

// Set initial lang attribute
document.documentElement.lang = initialLang;
syncDayjsLocale(initialLang);

export default i18n;
